<template>
  <div class="h-full flex flex-col">
    <div class="p-4 flex-1 flex flex-col overflow-y-scroll whitespace-pre-wrap">
      {{
        counter >= 0
          ? `ただいま、ふりかえり画面（がめん）を準備中（じゅんびちゅう）です。\n
時間（じかん）がかかる場合（ばあい）はホーム画面へもどります。\n
その場合は、ホーム画面下（した）の「学習履歴（がくしゅうりれき）」からふりかえりを入力（にゅうりょく）してください。`
          : ""
      }}
    </div>
  </div>
</template>

<script lang="ts">
import store, { awaitStudentLoaded } from "@/store";
import { getLearningsOf } from "@/api/learning";
import { Vue } from "vue-class-component";
import dayjs from "dayjs";

export default class ReflectionLatest extends Vue {
  timerId = -1;
  counter = 0;
  async created() {
    const student = await awaitStudentLoaded(store);
    this.timerId = setInterval(async () => {
      const learnings = await getLearningsOf(student.ref);
      if (
        learnings?.[0] &&
        learnings[0].data &&
        !learnings[0].data.reflection &&
        dayjs().unix() - learnings[0].data.timestamp < 60 * 60 * 1
      ) {
        // 最新の learning ドキュメントが直前に作られたものであれば、ここで対象とするドキュメントである
        clearInterval(this.timerId);
        this.counter = 0;
        this.$router.push(`/learning/${learnings[0].ref.id}/reflection`);
      } else if (this.counter <= 5) {
        this.counter++;
      } else {
        // 一定回数試行したが振り返り未記入の learning ドキュメントが取得できなかった
        clearInterval(this.timerId);
        this.counter = 0;
        this.$router.push("/");
      }
    }, 5000);
  }
}
</script>
